export const enum PageQueryKey {
  // RecentlyRead = 'page_list_recently_read',
  // Archive = 'page_list_archive',
  // MyList = 'page_list_my_list',
  // ReadLater = 'page_list_read_later',
  // Starred = 'page_list_starred',
  PageDetail = 'page_detail',
  PageList = 'page_list',
  Search = 'page_search',
  // ConnectorListPrefix = 'connector_list_',
  // AllFeeds = 'all_feeds',
  // FolderListPrefix = 'folder_list_'
}